module.exports = __webpack_public_path__ + "img/announce_with_play.43175d3b.jpg";